import * as React from "react";
import PropTypes from "prop-types";
import {Button, Card, Header, Segment} from "semantic-ui-react";
import {async} from "ith-fetch";
import {GET} from "ith-fetch";
import {NavLink} from "react-router-dom";

export default class GeneralView extends React.Component {
	static propTpyes = {
		onClearMetadataCache: PropTypes.func,
		clearingMedatadataCache: PropTypes.bool,
	};
	state = {
		success: false,
		updating: false
	};
	onSuccess = () => {
		this.setState({success: true}, () => async())
	};
	
	_update = async() => {
		try {
			this.setState({updating: true});
			await GET('/version');
		} catch (e) {
			console.log(e);
		} finally {
			this.setState({updating: false});
		}
	};
	
	render() {
		const {
			onClearMetadataCache,
			clearingMetadataCache
		} = this.props;
		
		const {updating} = this.state;
		return (
			<Segment basic style={{margin: -10}}>
				<Card style={{display: 'inline-flex', margin: 20}}>
					<Card.Content textAlign={'center'}>
						<Header>
							Versions-Update triggern
						</Header>
					</Card.Content>
					<Card.Content extra textAlign={'center'}>
					<Button disabled={updating} loading={updating} onClick={this._update}>Ausühren</Button>
					</Card.Content>
				</Card>
				<Card style={{display: 'inline-flex', margin: 20}}>
					<Card.Content textAlign={'center'}>
						<Card.Header>
							Model-Metadata-Cache löschen
						</Card.Header>
						
					</Card.Content>
					<Card.Content extra textAlign={'center'}>
						<Button disabled={clearingMetadataCache} loading={clearingMetadataCache}
						        onClick={onClearMetadataCache}>Löschen</Button>
					</Card.Content>
				</Card>
				
				<Card style={{display: 'inline-flex', margin: 20}}>
					
					<Card.Content textAlign={'center'}>
						<Card.Header>SQL Dumps</Card.Header>
						
					</Card.Content>
					<Card.Content extra textAlign={'center'}>
						<NavLink to={'/general/dumps'}>Dumps verwalten</NavLink>
					</Card.Content>
				</Card>
				
			</Segment>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/GeneralView.js